
import marked from "marked";
import Vue from "vue";
import axios from "axios";
import { upgradeImagesInElement, ImageUpgradeHandle } from "@/utils/progressiveImages";

let rendererMD = new marked.Renderer();
marked.setOptions({
  renderer: rendererMD,
  gfm: true,
  breaks: false,
  pedantic: false,
  sanitize: false,
  smartLists: true,
  smartypants: false,
});
rendererMD.heading = function (text, level) {
  return `<h${level} style="margin-bottom:20px;margin-top:20px">${text}</h${level}>`;
};
rendererMD.link = function (href, title, text) {
  return `<a style="color:var(--color-primary);text-decoration:none;" href=${href}>${text}</a>`;
};

export default Vue.extend({
  data: () => ({
    group: 0 as any,
    text: "",
    papers: [] as any,
    paperNum: 0,
    articles: [] as any,
    articleNum: 0,
    _imageUpgradeHandle: null as ImageUpgradeHandle | null,
  }),
  computed: {
    markdown(): string {
      return marked(this.text);
    },
  },
  mounted() {
    let name = this.$route.name ? this.$route.name : "1";
    if (name.startsWith("fe")) this.group = 1;
    else if (name.startsWith("asr")) this.group = 2;
    else if (name.startsWith("tts")) this.group = 3;
    else if (name.startsWith("sv")) this.group = 4;
    else this.group = 0;

    axios
      .post(Vue.prototype.apiUrl("get-item"), {
        collection: "intro",
        need: { index: this.group },
      })
      .then((response) => {
        let tmp = (response.data as any)[0].content;
        this.text = Vue.prototype.replaceLocalhostInContent(tmp);
        this.$nextTick(() => {
          const root = this.$refs.mdBody as HTMLElement | undefined;
          if (root) this._imageUpgradeHandle = upgradeImagesInElement(root);
        });
      });

    axios
      .post(Vue.prototype.apiUrl("get-item-num"), {
        collection: "achievement",
        need: { group: this.group, type: 0 },
      })
      .then((response) => {
        this.paperNum = (response.data as any).num;
      });
    this.getPaperList();

    axios
      .post(Vue.prototype.apiUrl("get-item-num"), {
        collection: "article",
        need: { type: "recommend", group: this.group },
      })
      .then((response) => {
        this.articleNum = (response.data as any).num;
      });
    this.getArticleList();
  },
  beforeDestroy() {
    if (this._imageUpgradeHandle) {
      this._imageUpgradeHandle.destroy();
      this._imageUpgradeHandle = null;
    }
  },
  methods: {
    getPaperList() {
      axios
        .post(Vue.prototype.apiUrl("get-item-list"), {
          collection: "achievement",
          need: { group: this.group, type: 0 },
          page: 1,
          numInOnePage: 999,
        })
        .then((response) => {
          this.papers = response.data;
        });
    },
    getArticleList() {
      axios
        .post(Vue.prototype.apiUrl("get-item-list"), {
          collection: "article",
          need: { type: "recommend", group: this.group },
          page: 1,
          numInOnePage: 999,
        })
        .then((response) => {
          this.articles = response.data;
        });
    },
    gotoArticle(type: string, id: string, link: string, content: string) {
      if (link != "") {
        window.location.href = link;
      } else if (type == "recommend") {
        this.$router.push({ path: `/article/news/${id}` });
      } else if (content !== "") {
        this.$router.push({ path: `/article/${type}/${id}` });
      }
    },
  },
});
